setInterval(function() {
	$('.logo').toggleClass('active');
}, 2000);